import {
	TopicCategory,
	PopoverVisibility,
	TemplateCategory,
	TranscriptionOrigin
} from "@teaming/common-enums";

import {
	newTemplateForm,
	newRecurrenceForm, newOneTimeMeetingForm
} from "./forms";

const langNamespace = "common-team.stores.Stream";

export const pristineTemplateState = () => ( {
	content: [],
	meetingTemplateId: "",
	title: "",
} );

export const pristineCursorState = () => ( {
	shared: {}, private: {},
} );

export const pristineTopicCategory = () => ( {
	category: "",
	description: "",
	topics: [],
} );

export const pristineTranscription = ( subDocId = "" ) => ( {
	speechBlocks: [],
	subDocId,
} );

export const pristineRecurrenceInfo = ( subDocId = "" ) => ( {
	recurrenceId: "",
	recurrenceEntryId: "",
	managedBy: "ui",
	subDocId,
} );

export const pristineTranscriptionSummary = subDocId => ( {
	id: "",
	itemizedSummary: [],
	origin: TranscriptionOrigin.BOT,
	rating: -1,
	status: "",
	subDocId,
	subStatus: "",
	summary: "",
	transcriptionStatusCycle: 0,
} );

export const pristineState = i18n => ( {
	busy: {},
	currentDocType: "",
	currentTeam: {
		id: "",
		members: [],
	},
	currentTeamId: "",
	cursors: pristineCursorState( i18n ),
	customTemplates: [],
	documentName: "",
	isInitialized: false,
	isNavigationSidebarExpanded: true,
	isTranscriptionBotPromptVisible: false,
	isTranscriptionUploadPromptVisible: false,
	/** @deprecated controls the visibility of the virtual meeting URL form for sub-docs (TODO: remove) */
	meetingAssistantSubDocId: "",
	myTeams: [],
	newTemplateForm: newTemplateForm( { i18n, } ),
	newTemplateFormVisibility: PopoverVisibility.INDETERMINATE,
	// FIXME: this is temporary
	oneTimeMeetingForm: newOneTimeMeetingForm( { i18n, } ),
	oneTimeMeetingFormVisibility: PopoverVisibility.INDETERMINATE,
	oneTimeMeetings: [],
	popoverSubDocId: "",
	recurrenceForm: newRecurrenceForm( { i18n, } ),
	recurrenceFormVisibility: PopoverVisibility.INDETERMINATE,
	recurrenceListVisibility: PopoverVisibility.INDETERMINATE,
	recurrences: [],
	icsMeetingInstructionsVisibility: false,
	/** topic ID => timestamp - topics the user has previously selected for use */
	selectedSuggestedTopics: {},
	selectedTemplateCategory: TemplateCategory.TEAM_TEMPLATES,
	/** template ID => timestamp - templates the user has previously selected for use */
	selectedTemplates: {},
	selectedTopicCategory: TopicCategory.ICEBREAKERS,
	subDocSyncCycle: 0,
	subDocs: [],
	suggestedTemplates: [],
	suggestedTopics: [],
	templateBrowserVisibility: PopoverVisibility.INDETERMINATE,
	templatePreview: pristineTemplateState( i18n ),
	templatePreviewVisibility: PopoverVisibility.INDETERMINATE,
	templateTeamCategories: [
		{
			description: i18n.global.t( `${ langNamespace }.templateCategory${ TemplateCategory.MY_TEMPLATES }description` ),
			placeholder: i18n.global.t( `${ langNamespace }.templateCategory${ TemplateCategory.MY_TEMPLATES }placeholder` ),
			sortKey1: 0,
			sortKey2: "",
			suffix: "",
			text: i18n.global.t( `${ langNamespace }.templateCategory${ TemplateCategory.MY_TEMPLATES }label` ),
			value: TemplateCategory.MY_TEMPLATES,
		},
	],
	topicBrowserVisibility: PopoverVisibility.INDETERMINATE,
	/** subDocId => summary - transcription summaries for sub docs */
	transcriptionSummaries: {},
	transcriptionViewedSubDocId: "",
	/** subDocId => boolean - is the transcription wizard enabled for the sub doc? */
	transcriptionWizards: {},
	/** subDocId => transcription - transcriptions for sub docs */
	transcriptions: {},
	recurrenceInfos: {},
} );
